import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  private authStore = inject(AuthStore);
  private router = inject(Router);
  private toastService = inject(ToastService);

  canActivate(): boolean | UrlTree {
    const isAuthInitialized = this.authStore.isAuthInitialized();
    const isAuthenticated = this.authStore.isAuthenticated();
    
    // If auth is not initialized yet, allow access temporarily
    // The auth state change will handle redirection once initialized
    if (!isAuthInitialized) {
      return true;
    }
    
    if (isAuthenticated) {
      // User is already logged in, redirect to home
      this.toastService.info('You are already logged in.');
      return this.router.createUrlTree(['/']);
    }
    
    // User is not authenticated, allow access to guest pages
    return true;
  }
}